const loadablePreloadRegistry = new Set();
export function addPreload(component) {
  loadablePreloadRegistry.add(component);
}
function removePreload(component) {
  loadablePreloadRegistry.delete(component);
}

/**
 * Preloads all Loadable components that have been created.
 *
 * Used by foundations-components-test-utils test lifecycle hooks to ensure tests consistency
 */
export async function preloadAllLoadables(currentRecursiveCallsDepth = 0, maxRecursiveCalls = 20) {
  if (currentRecursiveCallsDepth >= maxRecursiveCalls) {
    console.warn(`Loadable preload recursion limit reached (limit: ${maxRecursiveCalls}), possible circular dependency found`);
    return;
  }
  const preloads = Array.from(loadablePreloadRegistry.values());
  if (preloads.length === 0) {
    return;
  }
  const results = await Promise.allSettled(preloads.map(preload => preload()));
  results.forEach((result, index) => {
    if (result.status === 'rejected') {
      console.error('Error preloading Loadable component', result.reason);
    }
    removePreload(preloads[index]);
  });

  // One Loadable component may add another Loadable component to the registry, and so on
  if (loadablePreloadRegistry.size > 0) {
    return preloadAllLoadables(currentRecursiveCallsDepth + 1, maxRecursiveCalls);
  }
}